import { createSlice } from "@reduxjs/toolkit";
import { handleLoading } from "redux/redux-util";

const initialState = {
  loading: false,
  fetchingProductComplex: false,
  securities: [],
  paymentList: [],
  productDetail: undefined,
  filterSecurity: null,
  banners: [],
  error: null,
};

const slice = createSlice({
  initialState,
  name: "product",
  reducers: {
    getPrimaryProducts: handleLoading,
    getPrimaryProductsSuccess: (state, action) => {
      state.loading = false;
      state.securities = action.payload;
    },
    getPrimaryProductsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getPrimaryProductDetail: (state, action) => {
      if (!action.payload.skipClearSecurityData) {
        state.loading = true;
        state.productDetail = undefined;
        state.currentSecurity = action.payload.securityCode;
      }
    },
    getPrimaryProductDetailSuccess: (state, action) => {
      state.loading = false;
      state.productDetail = action.payload;
      state.currentSecurity = action.payload.securityCode;
    },
    getPrimaryProductDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getComplexProduct: (state) => {
      if (!state.paymentList?.length) {
        state.fetchingProductComplex = true;
      }
    },
    getComplexProductSuccess: (state, action) => {
      state.fetchingProductComplex = false;
      state.paymentList = action.payload;
    },
    getComplexProductFailure: (state, action) => {
      state.fetchingProductComplex = false;
      state.paymentList = null;
      state.error = action.payload;
    },
    getComplexProductDetail: (state, action) => {
      return {
        ...state,
        loading: true,
        productDetail: undefined,
        currentSecurity: action.payload.securityCode,
      };
    },
    getComplexProductDetailSuccess: (state, action) => {
      return { ...state, loading: false, productDetail: action.payload };
    },
    getComplexProductDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchingProductDetailDone: (state) => {
      state.loading = false;
    },
    updateProductLombardDetail: (state, { payload }) => {
      state.productDetail = {
        ...state.productDetail,
        ...payload,
      };
    },
    clearLombardDetail: (state) => {
      state.productDetail.useLombard = false;
      state.productDetail.sellMaxUnit = state.productDetail.sellMaxUnitOrigin;
      state.productDetail.lombardAvailableUnit = null;
      state.productDetail.lombardAvailableAmount = null;
    },
    setFilterSecurity: (state, action) => {
      state.filterSecurity = action.payload;
    },
    fetchBanner: (state) => {
      state.bannerLoading = true;
    },
    fetchBannerSuccess: (state, action) => {
      state.bannerLoading = false;
      state.banners = action.payload;
    },
    fetchBannerFailure: (state) => {
      state.bannerLoading = false;
      state.banners = state.banners || [];
    },
    resetError: (state) => {
      state.error = null;
    },
    closeLoadingIndex: (state) => {
      state.loading = false;
      state.currentSecurity = null;
    },
  },
});

export const {
  getPrimaryProducts,
  getPrimaryProductsSuccess,
  getPrimaryProductsFailure,
  getPrimaryProductDetail,
  getPrimaryProductDetailSuccess,
  getPrimaryProductDetailFailure,
  getComplexProduct,
  getComplexProductSuccess,
  getComplexProductFailure,
  getComplexProductDetail,
  getComplexProductDetailSuccess,
  getComplexProductDetailFailure,
  fetchingProductDetailDone,
  updateProductLombardDetail,
  clearLombardDetail,
  setFilterSecurity,
  fetchBanner,
  fetchBannerSuccess,
  fetchBannerFailure,
  resetError,
  closeLoadingIndex,
} = slice.actions;

export default slice.reducer;
